import { conversationDraftState } from '../singleton';

export const useConversationDraft = (conversationId: string) => {
  return conversationDraftState((state) => ({
    content: state.conversationContent[conversationId] || '',
    setContent: state.setConversationContent,
  }));
};
